import '../../styles/design-system.css';

/**
 * Metadata tag.
 * variant: 'default' | 'slash'
 */
export function Tag({ children, variant = 'default' }) {
  return (
    <span className={variant === 'slash' ? 'ds-tag ds-tag--slash' : 'ds-tag'}>
      {children}
    </span>
  );
}

export default Tag;
